/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */
// Libraries
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    fetchEntityRequest,
    updateUserRequest,
    updateAdminUserRequest,
    updateUserReset,
    createUserReset,
} from '../../containers/UserManagement/redux/userManagement.actions';
import { getIntent } from '../../utils/helperMethods';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

// Actions

// Styles
import './userMakerView.scss';

const UserMakerView = props => {
    const { data } = props;

    return (
        <form className="create-user-form user-view-maker">
            <div>
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    <div
                        className={`status ${data.userStatus &&
                            data.userStatus.split(' ').join('')}`}
                    >
                        <span className="text-simple">{data.userStatus}</span>
                        {data.userStatusOld &&
                        data.userStatus !== data.userStatusOld ? (
                            <span className="strike-through">
                                {data.userStatusOld}
                            </span>
                        ) : null}
                    </div>
                    <div className="lastupdate-status">
                        {/* {data.lastUpdatedByName && (
                            <>
                                Last Edit : {data.lastUpdatedByName},{' '}
                                {moment(data.lastUpdatedDate, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.lastUpdatedDate, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.lastUpdatedDate}
                            </>
                        )} */}
                        {data.userCreatedUpdatedName && (
                            <>
                                {getIntent(data.lastActions)}{' '}
                                <strong>{data.userCreatedUpdatedName}, </strong>
                                {moment(data.userCreatedDate, 'DD/MM/YYYY')
                                    .calendar()
                                    .indexOf('Today') >= 0
                                    ? 'Today'
                                    : moment(data.userCreatedDate, 'DD/MM/YYYY')
                                          .calendar()
                                          .indexOf('Yesterday') >= 0
                                    ? 'Yesterday'
                                    : data.userCreatedDate}
                            </>
                        )}
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field" style={{ marginRight: '25px' }}>
                        <p className="label">Email ID</p>
                        <p className="user-text email">{data.email}</p>
                    </div>
                    <div className="form-field">
                        <p className="label">Role</p>
                        <p className="user-text">
                            <span className="text-simple">
                                {data.userRoleName}
                            </span>
                            {data.userRoleNameOld &&
                            data.userRoleName !== data.userRoleNameOld ? (
                                <span className="strike-through">
                                    {data.userRoleNameOld}
                                </span>
                            ) : null}
                        </p>
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">User Level</p>
                        <p className="user-text">
                            <span className="text-simple">
                                {data.userLevel}
                            </span>
                            {data.userLevelOld &&
                            data.userLevelOld !== data.userLevel ? (
                                <span className="strike-through">
                                    {data.userLevelOld}
                                </span>
                            ) : null}
                        </p>
                    </div>
                </div>
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">{data.userLevel}</p>
                        <div className="form-field disabled">
                            <span className="text-simple">
                                {data.entityName}
                            </span>
                            {data.entityNameOld &&
                            data.entityNameOld !== data.entityName ? (
                                <span className="strike-through">
                                    {data.entityNameOld}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="form-section comment-box">
                    <p className="label">Comment</p>
                    <p className="comment-text">
                        {data.checkerComment
                            ? data.checkerComment
                            : data.makerComment || '-'}
                    </p>
                </div>
            </div>
        </form>
    );
};

const mapStateToProps = ({ auth, userManagementData, form }) => ({
    auth,
    userManagementData,
    formData: form['user-checker-view'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            fetchEntityRequest,
            updateUserRequest,
            updateAdminUserRequest,
            updateUserReset,
            createUserReset,
        },
        dispatch
    ),
});

UserMakerView.propTypes = {
    data: PropTypes.object,
};

export default compose(
    reduxForm({
        form: 'user-checker-view',
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(UserMakerView);
